import React, { useEffect } from 'react';
import clsx from 'clsx';
import SportsTeamLogo from 'components/teamLogo';
import style from './style.module.scss';
import { observer } from 'mobx-react';
import HockeyTracker from './tracker';
import HockeyViewRegular from './regular';
import HockeyViewRecord from './record';
import useStore from '../../../../hooks/useStore';
import Banner from '../../../../components/banner';
import { _SPORTS_TYPE } from '../../../../common/constants/sportsConstants';
import { getStreamBrowser } from '../../liveStream/util/index';

const HockeyView = observer(({ item, isSelected, setSelectedGame, isAdmin, openCaster, isPopup }) => {
  const { periodArr, oddsData, summaryScore } = item;
  const { bannerStore } = useStore();

  useEffect(() => {
    if (!bannerStore.activeMajorViewId || bannerStore.activeMajorViewId === 'placeholder') {
      if (Number.isInteger(item.id)) {
        bannerStore.setActiveMajorView(item.id, _SPORTS_TYPE.HOCKEY);
      }
    }
  }, [bannerStore, bannerStore.activeMajorViewId, item.id]);

  const onClickDetail = () => {
    window.open(`/match/hockey/${item.id}`, `detail_${item.id}`, 'width=1000px,height=901px,scrollbars=yes');
  };

  const onClickVideo = () => {
    getStreamBrowser(item.videoLink);
  };

  const onClickBetble = () => {
    let type = 0;

    if (item.getTracker.status === 'progress') {
      type = 1;
    }

    const url = `https://betble.com/game/game.php?type=${type}${item.betbleUri}`;

    window.open(url);
  };

  const setSelectedItem = () => {
    setSelectedGame(isSelected, item.id, item.startDatetime, item.gameStatus, 'icehockey');
  };

  return (
    <>
      <div className={style.score_board}>
        {/* tracker  */}
        <HockeyTracker item={item} isPopup={isPopup} />
        {/*// tracker  */}

        {/* summary_score  */}
        <div className={style.summary_score}>
          <div className={style.info}>
            <span className={style.league}>{item.league.shortName}</span>
            <span className={style.time}>{item.getStartDateTime}</span>
            {item.getTracker.status === 'progress' && item.gameStatus !== 'BREAK_TIME' && (
              <span className={style.displayTime}>{item.displayTime}</span>
            )}
            <span className={clsx(style.state, item.getTracker.status === 'progress' && style.on)}>
              {item.statusText}
            </span>
          </div>
          <div className={style.team_area}>
            <div className={clsx(style.team, style.away)}>
              <SportsTeamLogo imgSize={'55'} imgUrl={!!item.teams ? item.teams.away.imgPath : null} isLazy={true} />
              <div className={style.name}>
                <span>{item.getTeamData.away.name}</span>
              </div>
              <div className={clsx(style.point, item.winnerTeam.activeScore === 'away' && style.on)}>
                {item.getTeamData.away.score}
              </div>
            </div>
            <div className={clsx(style.team, style.home)}>
              <SportsTeamLogo imgSize={'55'} imgUrl={!!item.teams ? item.teams.home.imgPath : null} isLazy={true} />
              <div className={style.name}>
                <span>{item.getTeamData.home.name}</span>
              </div>
              <div className={clsx(style.point, item.winnerTeam.activeScore === 'home' && style.on)}>
                {item.getTeamData.home.score}
              </div>
            </div>
          </div>
          <div className={style.btn_area}>
            {!isPopup && (
              <>
                <button
                  className={clsx(style.btn, style.btn_arrow, isSelected ? style.down : style.up)}
                  onClick={setSelectedItem}
                >
                  올리기/내리기
                </button>
                <button className={clsx(style.btn, style.btn_lineup)} onClick={onClickDetail}>
                  상세보기
                </button>
                {/*{item.betbleButtonVisible && (*/}
                {/*  <button*/}
                {/*    className={clsx(style.btn, style.betting)}*/}
                {/*    onClick={onClickBetble}*/}
                {/*  >*/}
                {/*    베팅*/}
                {/*  </button>*/}
                {/*)}*/}
                {!!item.videoLink &&
                  (item.gameStatus === 'IN_PROGRESS' ||
                    item.gameStatus === 'BREAK_TIME' ||
                    item.gameStatus === 'PAUSE') && (
                    <button className={clsx(style.btn, style.btn_live)} onClick={onClickVideo}>
                      생중계
                    </button>
                  )}
                {isAdmin && (
                  <button className={clsx(style.btn, style.btn_admin)} onClick={() => openCaster(5, item.id)}>
                    AD
                  </button>
                )}
              </>
            )}
          </div>
          <span className={style.total_score}>합계 : {summaryScore}</span>
        </div>
        {/*// summary_score  */}

        {/* detail_score  */}
        <div className={style.detail_score}>
          <div className={clsx(style.board, style[item.getTracker.class])}>
            {item.getTracker.status === 'ready' ? (
              <HockeyViewRecord item={item} />
            ) : (
              periodArr.map((quarter) => {
                return <HockeyViewRegular quarter={quarter} item={item} key={`hockey-regular-${quarter.key}`} />;
              })
            )}
            <dl className={clsx(style.item, style.odds)} style={{ borderRight: 'none' }}>
              <dt>기준</dt>
              <dd>
                <span>{!!oddsData.international.away && oddsData.international.away}</span>
                <span>{!!oddsData.international.awayOption && oddsData.international.awayOption}</span>
              </dd>
              <dd>
                <span>{!!oddsData.international.home && oddsData.international.home}</span>
                <span>{!!oddsData.international.homeOption && oddsData.international.homeOption}</span>
              </dd>
            </dl>
          </div>
          {/* <div className={style.stadium}>
            <span className={style.tx}>{venueName}</span>
          </div> */}
        </div>
        {/*// detail_score  */}
      </div>
      {bannerStore.activeMajorViewId === item.id ? <Banner paddingTop='10px' paddingBottom='0' /> : null}
    </>
  );
});

export default HockeyView;
